<script setup lang="ts">
    import Source from '../../../app/crm/models/Source';
    import SourceCollection from '../../../app/crm/collections/SourceCollection';
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    interface Props extends FormInputProps {
        closeOnSelect?: boolean;
        multiple?: boolean;
        formKey?: string;
    }
    const props = withDefaults(defineProps<Props>(), {
        closeOnSelect: true,
        multiple: false,
        formKey: 'source',
    });

    const inputData: FormInputData = useFormInput(props);

    const select = ref(null);
    const setValue = (value: Source | Array<Source>) => {
        inputData.form.set(props.formKey, value);
    };
</script>

<template>
    <FormElement
        :input-data="inputData"
        @label-clicked="select?.show()"
    >
        <SelectSource
            ref="select"
            :with-create-button="true"
            :initial-value="inputData.model"
            :close-on-select="closeOnSelect"
            :multiple="multiple"
            @selected="setValue"
        ></SelectSource>
    </FormElement>
</template>
